<template>
  <div
    v-if="visible"
    class="promotion-banner"
    :class="[position, customClass]"
    role="region"
    aria-label="Anuncios y promociones"
  >
    <div class="banner-pattern"></div>
    <div class="banner-shine"></div>

    <div class="banner-marquee">
      <Marquee :speed="35" :pause-on-hover="true">
        <slot>
          <span class="banner-item">
            <span class="banner-emoji">📍</span>
            <span>HOME STUDIO EN <em class="banner-highlight">Maipú</em></span>
            <span class="banner-emoji">💕</span>
          </span>
          <span class="banner-separator">◆</span>
          <span class="banner-item">
            <span class="banner-emoji">🍪</span>
            <span>INCLUYE UN BEBESTIBLE DE CORTESÍA</span>
            <span class="banner-emoji">☕</span>
          </span>
          <span class="banner-separator">◆</span>
          <span class="banner-item">
            <span class="banner-emoji">💅🏻</span>
            <span>MANICURE INCLUYE EXFOLIACIÓN E HIDRATACIÓN <em class="banner-highlight">Gratis</em></span>
            <span class="banner-emoji">✨</span>
          </span>
          <span class="banner-separator">◆</span>
          <span class="banner-item">
            <span class="banner-emoji">🎁</span>
            <span>REGALA ESTA EXPERIENCIA CON UNA <em class="banner-highlight">Giftcard</em></span>
            <span class="banner-emoji">💌</span>
          </span>
          <span class="banner-separator">◆</span>
        </slot>
      </Marquee>
    </div>

    <button
      v-if="closeable"
      @click="closeBanner"
      class="close-button"
      aria-label="Cerrar banner"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PromotionBanner',
  props: {
    initialVisibility: {
      type: Boolean,
      default: true
    },
    closeable: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'static',
      validator: (value) => ['static', 'fixed-top', 'fixed-bottom', 'sticky-top'].includes(value)
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: this.initialVisibility
    }
  },
  methods: {
    closeBanner() {
      this.visible = false;
      this.$emit('close');
    },
    show() {
      this.visible = true;
      this.$emit('show');
    },
    hide() {
      this.visible = false;
      this.$emit('hide');
    },
    toggle() {
      this.visible = !this.visible;
      this.$emit(this.visible ? 'show' : 'hide');
    }
  }
}
</script>

<style scoped>
.promotion-banner {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.7rem 1rem;
  overflow: hidden;
  z-index: 50;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  background: linear-gradient(135deg, #5d3677 0%, #734A91 35%, #65209D 70%, #4f1b7d 100%);
  box-shadow: 0 2px 14px rgba(80, 25, 130, 0.35);
}

/* Patrón sutil de puntos sobre el degradado */
.banner-pattern {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px);
  background-size: 18px 18px;
  pointer-events: none;
  opacity: 0.7;
}

/* Brillo animado que cruza el banner */
.banner-shine {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 35%;
  left: -50%;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.10) 50%,
    transparent 100%);
  transform: skewX(-18deg);
  pointer-events: none;
  animation: bannerShine 9s ease-in-out infinite;
}

@keyframes bannerShine {
  0%   { left: -50%; }
  60%  { left: 130%; }
  100% { left: 130%; }
}

.banner-marquee {
  position: relative;
  flex: 1;
  z-index: 1;
  /* Fundido en los bordes */
  -webkit-mask-image: linear-gradient(90deg,
    transparent 0%,
    #000 7%,
    #000 93%,
    transparent 100%);
  mask-image: linear-gradient(90deg,
    transparent 0%,
    #000 7%,
    #000 93%,
    transparent 100%);
}

.banner-item {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0 1.5rem;
  vertical-align: middle;
}

.banner-emoji {
  display: inline-block;
  font-size: 1rem;
  transition: transform 0.3s ease;
}

.banner-item:hover .banner-emoji {
  transform: scale(1.15) rotate(-5deg);
}

/* Separador decorativo entre mensajes */
.banner-separator {
  display: inline-block;
  margin: 0 0.4rem;
  font-size: 0.55rem;
  color: rgba(255, 255, 255, 0.45);
  vertical-align: middle;
  transform: translateY(-1px);
}

/* Énfasis tipográfico en palabras clave */
.banner-highlight {
  font-family: 'Playfair Display', Georgia, serif;
  font-style: italic;
  font-weight: 600;
  font-size: 1.05rem;
  letter-spacing: 0;
  text-transform: none;
  color: #ffffff;
  margin: 0 0.15rem;
  padding-bottom: 1px;
  border-bottom: 1px dotted rgba(255, 255, 255, 0.5);
}

/* Posicionamiento */
.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}

.fixed-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.sticky-top {
  position: sticky;
  top: 0;
}

/* Botón cerrar */
.close-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-left: 0.6rem;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.32);
  color: #ffffff;
  cursor: pointer;
  z-index: 2;
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1),
              background-color 0.3s ease,
              border-color 0.3s ease;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.28);
  border-color: rgba(255, 255, 255, 0.6);
  transform: rotate(90deg) scale(1.08);
}

.close-button svg {
  width: 14px;
  height: 14px;
}

@media (max-width: 768px) {
  .promotion-banner {
    font-size: 0.72rem;
    letter-spacing: 0.14em;
    padding: 0.55rem 0.75rem;
  }
  .banner-item {
    margin: 0 1rem;
    gap: 0.4rem;
  }
  .banner-highlight {
    font-size: 0.95rem;
  }
  .banner-emoji {
    font-size: 0.9rem;
  }
}
</style>
